import React from 'react'
import { IconButton, Icon } from 'rsuite'

export default function SearchButton({ onClick, children = 'ค้นหา', disabled, ...props }) {
  return (
    <IconButton
      appearance="ghost"
      className="rs-btn-ghost-save"
      style={{
        marginRight: 10,
        marginBottom: 10,
      }}
      onClick={onClick}
      icon={<Icon appearance="ghost" icon="search" className="bt-gost-icon-radius" />}
      disabled={disabled}
      {...props}
    >
      {children}
    </IconButton>
  )
}
